import { useQuery } from "@tanstack/react-query";

import { fetchSecurityOverview } from "../api/securityApi";
import type { SecurityRange } from "../types";

export const securityKeys = {
  overview: (range: SecurityRange) => ["security", "overview", range] as const,
};

export const useSecurityOverviewQuery = (range: SecurityRange = "day") =>
  useQuery({
    queryKey: securityKeys.overview(range),
    queryFn: () => fetchSecurityOverview(range),
    refetchInterval: 15_000,
  });
